import { z } from 'zod'
import { zoneSchema } from './zone.dto.js'
import { staticLabelSchema } from './static-label.dto.js'
import { venueSpaceDtoSchema } from './venue.dto.js'

/** Dry-run: dimensions and zone counts extracted from a legacy layout SVG. */
export const spaceImportPreviewDtoSchema = z.object({
  spaceId: z.string().uuid(),
  spaceName: z.string(),
  versionId: z.string().uuid(),
  versionLabel: z.string(),
  /** Current space dimensions (editor pixels). */
  currentWidth: z.number(),
  currentHeight: z.number(),
  /** Dimensions implied by the SVG after conversion. */
  suggestedWidth: z.number(),
  suggestedHeight: z.number(),
  zoneCount: z.number().int().nonnegative(),
  fillZoneCount: z.number().int().nonnegative(),
  strokeZoneCount: z.number().int().nonnegative(),
  /** Free text labels extracted as editable static labels. */
  labelCount: z.number().int().nonnegative(),
  /**
   * Furniture pieces found in the SVG that this import intentionally skips.
   * Users place those via the event Import tab (catalog + phase plan).
   */
  furniturePlacementCount: z.number().int().nonnegative(),
  /** Sticky notes found in the SVG (also event-import only). */
  notePlacementCount: z.number().int().nonnegative(),
  /** True when suggested size differs meaningfully from the current version. */
  sizeChange: z.boolean(),
})

export type SpaceImportPreviewDto = z.infer<typeof spaceImportPreviewDtoSchema>

/** Apply result: updated space DTO for the version that was written. */
export const spaceImportApplyResultDtoSchema = z.object({
  space: venueSpaceDtoSchema,
  summary: z.object({
    width: z.number(),
    height: z.number(),
    zoneCount: z.number().int().nonnegative(),
    labelCount: z.number().int().nonnegative(),
  }),
  /** Zones that were written (for client cache/canvas if needed). */
  zones: z.array(zoneSchema),
  /** Static labels written from SVG text. */
  labels: z.array(staticLabelSchema),
})

export type SpaceImportApplyResultDto = z.infer<typeof spaceImportApplyResultDtoSchema>
